import { render } from "./GrigliaFacile.vue?vue&type=template&id=20ab8872&scoped=true"
import script from "./GrigliaFacile.vue?vue&type=script&lang=js"
export * from "./GrigliaFacile.vue?vue&type=script&lang=js"

import "./GrigliaFacile.vue?vue&type=style&index=0&id=20ab8872&scoped=true&lang=css"

import exportComponent from "C:\\Users\\diego\\source\\repos\\PoligeoDocumenti\\PoligeoDocumenti\\poligeo-documenti\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ab8872"]])

export default __exports__